module.exports = __webpack_public_path__ + "static/media/logo.5c0e561b.png";